import { Injectable } from '@angular/core';

import { Entity, Predicate } from 'breeze-client';
import { EntityManagerProvider } from './entity-manager-provider';
import { Guid, Entities, User } from './entities';
import { UnitOfWork } from './unit-of-work';
import { Repository } from './repository';
// import { ProjectRepository } from './project.repository';

@Injectable({
    providedIn: 'root'
})
export class AppUnitOfWork extends UnitOfWork {
    // projects: ProjectRepository;
    users: Repository<User>;

    constructor(emProvider: EntityManagerProvider) {
        super(emProvider);
        // this.projects = new ProjectRepository(this.manager);
        this.users = this.createRepository<User>('User', 'users');
    }
}
